import React from 'react'
import clsx from 'clsx'

import ButtonSecondary from '../ButtonSecondary'

import useStyles from './styles'

const RedButton = ({
  onClick,
  saving = false,
  disabled = false,
  children,
  className = ''
}) => {
  const classes = useStyles()

  return (
    <ButtonSecondary
      loading={saving}
      disabled={disabled}
      onClick={onClick}
      className={clsx(classes.root, className)}
    >
      {children}
    </ButtonSecondary>
  )
}

export default RedButton
